import React, {useEffect, useState} from 'react';
import MultiSelect from "./multi-select.jsx";
import {debounce} from "lodash";

const AsyncMultiSelect = (props) => {
    const [options, setOptions] = useState([]);
    const [selectInput, setSelectInput] = useState("");

    const loadOptions = debounce(async (inputValue = "") => {
        await props.loadOptions(inputValue, (e) => setOptions(e));
    }, 500);

    useEffect(loadOptions, []);

    const onInputChange = (inputValue, { action }) => {
        if (action === "input-blur" || action === 'set-value') return;

        if (action === "menu-close" && selectInput !== "") {
            setSelectInput("");
            loadOptions();
            return
        }

        setSelectInput(inputValue);
        loadOptions(inputValue);
    }

    return(
        <MultiSelect
            {...props}
            inputValue={selectInput}
            onInputChange={onInputChange}
            options={options}
            wrapValues={props.wrapValues}
        />
    )
};

export default AsyncMultiSelect;